import {isMobileDevice} from '../util/util';

dojo.require("dojox.data.XmlStore");

let zimgBasePath = window.location.origin;
let zImgPath = "//stage-zimg.zentuvo.com/zimg";

var env = process.env.NODE_ENV || 'development';
if (env === 'test') {
    zimgBasePath = "https://stage-zimg.zentuvo.com";
    zImgPath = "https://stage-zimg.zentuvo.com/zimg";
}
if (env === 'production') {
    zimgBasePath = "https://zimg.zentuvo.com";
    zImgPath = "https://zimg.zentuvo.com/zimg";
}


var custOpt = () => {
    if(isMobileDevice) {
        return {
            HOME: {name: "cHomeMobileHOME", value: ""},
            INTRO: {name: "cHomeMobileINTRO", value: ""},
            OUTRO: {name: "cHomeMobileOUTRO", value: ""},
            FLOORPLANS: {name: "cHomeMobileFLOORPLANS", value: ""}
        };
    } else {
        return {
            SOCIAL_MEDIA: {name: "cHomeRegularSOCIAL_MEDIA", value: ""},
            HOME: {name: "cHomeRegularHOME", value: ""},
            INTRO: {name: "cHomeRegularINTRO", value: ""},
            OUTRO: {name: "cHomeRegularOUTRO", value: ""},
            FLOORPLANS: {name: "cHomeRegularFLOORPLANS", value: ""}
        };
    }
};

var config = (project) => {
    let imageListXMLURL = zimgBasePath + "/zimg/imagelistxml-" + project + ".xml";
    let customerXMLURL = zimgBasePath + "/Customer/getCustomerZImageData/";
    let projectXMLUrl = zimgBasePath + "/Customer/getProjectZImageData/";
    let facebookURL = "https://www.facebook.com/sharer.php?u=" + encodeURIComponent(zimgBasePath + "/zhome/?project=" + project + "&t=zHome Zentuvo");
    let twitterURL = "http://twitter.com/share?url=" + encodeURIComponent(zimgBasePath + "/zhome/?project=" + project + "&text=zHome Zentuvo");

    return {zimgBasePath, imageListXMLURL, customerXMLURL, projectXMLUrl, facebookURL, twitterURL};
};

var configUrlsJson = {
    projectInfoUrl: zimgBasePath + "/Customer/projectInfo/",
    imageListUrl: zimgBasePath + (isMobileDevice ? "/zImg/ImageListDataService/mobileImageList/"
                                                 : "/zImg/ImageListDataService/imageList/"), //dev  http://34.252.174.77/zImg/ImageListDataService/imageList/8416
};

export { zImgPath, config, custOpt, configUrlsJson };
